import { ChevronDownIcon } from "@chakra-ui/icons";
import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  useMediaQuery,
} from "@chakra-ui/react";
import OrderSummary from "components/TicketingModal/TicketingModalOrderSummary";
import { useAtom } from "jotai";
import Image from "next/image";
import { useRouter } from "next/router";
import BackIcon from "public/images/back-button.svg";
import tbwCheckoutBanner from "public/images/tbw-banner/checkout-page.png";
import { ReactNode } from "react";
import {
  orderSummaryOpenAtom,
  successAtom,
  ticketingModalItemAtom,
  ticketingModalOpenAtom,
} from "utils/atoms";

export interface ModalItemProps {
  title: () => ReactNode;
  backButton?: (setModalItem: any) => void;
  children: () => ReactNode;
  actionButton?: () => ReactNode;
}

const TicketingModal = () => {
  const router = useRouter();
  const [success] = useAtom(successAtom);
  const [ticketingModal, setTicketingModal] = useAtom(ticketingModalOpenAtom);
  const [orderSummaryOpen, setOrderSummaryOpen] = useAtom(orderSummaryOpenAtom);

  const [modalItem, setModalItem] = useAtom(ticketingModalItemAtom);

  const [isMobile] = useMediaQuery("(max-width: 768px)");
  const size = isMobile ? "full" : "md";
  const variant = isMobile ? "full" : "custom";

  const _onClose = () => {
    setTicketingModal(false);
    router.push(
      {
        pathname: router.pathname,
      },
      undefined,
      { shallow: true }
    );
  };

  return (
    <Modal
      isOpen={ticketingModal && !success}
      onClose={_onClose}
      isCentered
      size={size}
      variant={variant}
      scrollBehavior="inside"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />

        <div className="flex flex-row items-stretch flex-grow h-full">
          <div className="flex flex-col items-center w-full md:w-[67.5%] h-full">
            {/* Modal title */}
            <div className="flex flex-row w-full items-center justify-center bg-neutral-900 p-4 sm:p-2 border-b-2 border-solid border-[black]">
              {modalItem?.backButton && (
                <div className="flex-grow mr-auto">
                  <div className="w-10 mr-auto flex-grow-0 svg-black">
                    <Image
                      src={BackIcon}
                      layout="responsive"
                      alt="back"
                      onClick={() => modalItem?.backButton?.(setModalItem)}
                    />
                  </div>
                </div>
              )}
              {modalItem?.title()}
            </div>

            {modalItem?.actionButton ? (
              <>
                <div className="flex p-4 md:p-12 gap-6 flex-col overflow-y-scroll w-full h-full bg-neutral-850">
                  {modalItem?.children()}
                </div>

                {modalItem?.actionButton?.()}
              </>
            ) : (
              <>{modalItem?.children()}</>
            )}
          </div>

          {/* Order summary pannel on the right for non-mobile */}
          <div className="w-[0%] md:flex bg-neutral-800 md:w-[42.5%] flex-col overflow-hidden">
            <Image src={tbwCheckoutBanner} alt="Astra Club" objectFit="cover" />
            <OrderSummary />
          </div>
        </div>

        {/* Order summary drawer for mobile view */}
        <Drawer
          placement={"bottom"}
          onClose={() => setOrderSummaryOpen(false)}
          isOpen={orderSummaryOpen}
        >
          <DrawerOverlay />
          <DrawerContent>
            <div className="flex flex-row justify-end bg-neutral-700 p-3">
              <ChevronDownIcon
                onClick={() => setOrderSummaryOpen(false)}
                w={8}
                h={8}
              />
            </div>
            <DrawerBody minH="70vh" bg="neutral.700">
              <OrderSummary />
            </DrawerBody>
          </DrawerContent>
        </Drawer>
      </ModalContent>
    </Modal>
  );
};

export default TicketingModal;
